import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import AdminPage from './components/AdminPage';
import { AuthProvider } from './contexts/AuthContext';

// Global styles for admin app
const AdminGlobalStyle = createGlobalStyle`
  :root {
    --vh: 1vh;
  }

  html, body {
    background-color: #f8f9fa;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior-x: none;
    overscroll-behavior-y: auto;
    width: 100%;
    min-height: 100vh;
    min-height: -webkit-fill-available;
    min-height: calc(var(--vh, 1vh) * 100);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  }

  html {
    min-height: -webkit-fill-available;
  }

  @supports (-webkit-appearance: none) {
    body {
      min-height: -webkit-fill-available;
    }
  }

  * {
    box-sizing: border-box;
  }
`;

const AdminAppContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  background: #f8f9fa;
`;

const AdminApp: React.FC = () => {
  // Set viewport height for iOS
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVH();
    window.addEventListener('resize', setVH);
    window.addEventListener('orientationchange', setVH);

    return () => {
      window.removeEventListener('resize', setVH);
      window.removeEventListener('orientationchange', setVH);
    };
  }, []);

  return (
    <Router>
      <AdminGlobalStyle />
      <AuthProvider>
        <AdminAppContainer>
          <Routes>
            <Route path="/" element={<AdminPage />} />
            <Route path="/admin" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AdminAppContainer>
      </AuthProvider>
    </Router>
  );
};

export default AdminApp;
